import React from 'react';
import * as _ from 'lodash';
import { createLocalEventManager } from '../utilities/EventManager';
import * as FormEle from './FieldFormElements';
import { deleteControlCode } from '../utilities/stringUtil';
import {
  COPY_FIELD_ADDRESS_SOURCE,
  COPY_FIELD_ADDRESS_TARGET,
} from '../utilities/constants';

/**
 * @description 入力された値の保持とsubmitを実行する Component
 */
export class Form extends React.Component {
  constructor(props) {
    super(props);

    if (!props.EventMg || !props.EventMg.isForm) {
      throw new Error(
        'EventManagerがpropsで渡されていません。' +
          'createFormEventManagerでEventMgを作成してPropsでForm Componentに渡してください。'
      );
    }

    this.params = {}; // 入力された値を保持
    this.companyId = parseInt(sessionStorage.getItem('company_id'), 10); // 元請ID

    //イベントを設定
    this.props.EventMg.addEventListener('submit', this.submit.bind(this));
    this.props.EventMg.addEventListener(
      'input_change_value',
      this.UpdateFormValue.bind(this)
    );
    // フォームが非表示になったときのイベント
    this.props.EventMg.addEventListener('delete_form_item', id => {
      delete this.params[id];
    });
  }

  componentDidMount() {
    this.props.EventMg.trigger('change_value', '', {});
  }

  // eslint-disable-next-line no-unused-vars
  UNSAFE_componentWillReceiveProps(nextProps) {
    this.props.EventMg.trigger('change_value', '', {});
  }

  /**
   * @description onChange Event を受け取る
   * @param { { target:Object,id:String } } event
   */
  UpdateFormValue(event) {
    const { id, value } = event;

    if (!id) {
      return;
    } // idが無いものは paramsに入れない。

    if (value !== '' && value !== null && value !== undefined) {
      // 配列じゃない時と、空の要素を削除して、元の配列が空では無い時は、更新する。( jvsは例外)
      if (
        !_.isArray(value) ||
        _.filter(value, v => !_.isEmpty(v)).length ||
        id === 'jvs'
      ) {
        this.params[id] = value;
      }
    } else {
      const copyFieldParams = _.concat(
        COPY_FIELD_ADDRESS_SOURCE,
        COPY_FIELD_ADDRESS_TARGET
      );
      if (_.includes(copyFieldParams, id) && _.isEmpty(value)) {
        // 転記する入力表は空白でも記録する
        this.params[id] = '';
      } else {
        delete this.params[id]; // paramsから削除
      }
    }
    this.props.EventMg.trigger('change_value', id, _.cloneDeep(this.params));
  }

  /**
   * @description EventMg.trigger("submit") されたら実行する
   */
  submit() {
    if (this.props.submit) {
      this.props.submit(_.clone(this.params));
    }
  }

  render() {
    return React.Children.map(this.props.children, child => {
      //section内を拡張
      if (_.has(child, 'type') && child.type === FormEle.FormSection) {
        let elements = React.Children.toArray(child.props.children);
        elements = _.map(elements, element =>
          React.cloneElement(element, { EventMg: this.props.EventMg })
        );
        return React.cloneElement(child, {}, elements);
      }
      // JSXにnullがあるとエラーになるため
      if (child !== null) {
        return React.cloneElement(child, { EventMg: this.props.EventMg });
      }
    });
  }
}

/**
 * @description Form Component へ イベント を送る Component
 */
export class FormItem extends React.Component {
  constructor(props) {
    super(props);

    if (!props.EventMg) {
      throw new Error(
        'EventManagerがpropsで渡されていません。' +
          'createFormEventManagerでEventMgを作成してPropsでForm Componentに渡してください。'
      );
    }

    this.state = {
      form_values: null,
      default_value: props.defaultValue,
    };

    this.is_enter = false; //一回でも入力されたかのフラグ
    // 入力フォーム以外のフォームID
    this.noInputForm = [
      /**
       * ------------利用者系画面項目------------
       */
      'login_id', //ユーザーID
      'user_role_code', // ユーザー種別
      'user_image', // ユーザーアイコン画像
      'company_id', // 元請会社ID
      'ccus_flag', // CCUS管理者フラグ
      'ccus_flag_admin', // CCUS管理者種別
      /**
       * ------------現場系画面項目------------
       */
      'company_branch_id', // 支店
      'buildee_user_id', // Buildee担当者
      'groundbreaking_date', // 着工日
      'complete_schedule_date', // 竣工予定日
      'work_hour_zone_day_flag', // 作業時間帯_昼間
      'work_hour_zone_night_flag', // 作業時間帯_夜間
      'work_hour_zone_midnight_flag', // 作業時間帯_深夜
      'earlytime_end', // 労働開始時刻(早出終了時刻)_昼間
      'overtime_start', // 労働終了時刻(残業開始時刻)_昼間
      'work_start_time', // 作業時間帯バー表示の開始時刻_昼間
      'work_end_time', // 作業時間帯バー表示の終了時刻_昼間
      'work_copy_time', // 予定→実施入力反映時刻_昼間
      'earlytime_end_night', // 労働開始時刻(早出終了時刻)_夜間
      'overtime_start_night', // 労働終了時刻(残業開始時刻)_夜間
      'work_start_time_night', // 作業時間帯バー表示の開始時刻_夜間
      'work_end_time_night', // 作業時間帯バー表示の終了時刻_夜間
      'work_copy_time_night', // 予定→実施入力反映時刻_夜間
      'earlytime_end_midnight', // 労働開始時刻(早出終了時刻)_深夜
      'overtime_start_midnight', // 労働終了時刻(残業開始時刻)_深夜
      'work_start_time_midnight', // 作業時間帯バー表示の開始時刻_深夜
      'work_end_time_midnight', // 作業時間帯バー表示の終了時刻_深夜
      'work_copy_time_midnight', // 予定→実施入力反映時刻_深夜
      'work_hour', // 1日あたりの労働時間
      'use_partner_company_approval_flag', // 協力会社承認機能
      'partner_input_result_flag', // 作業実績の入力を促す表示_協力会社
      'adjust_work_print_flag', // 職長の作業予定の印刷方法
      'crane_use_print_flag', // 揚重作業計画・作業指示書の印刷向き
      'work_and_diary_print_flag', // 作業間連絡及び調整実施記録
      'oxygen_lack_field_image_category_code', // 酸欠帳票に使用するキープラン
      'jvs', // jvs
    ];
  }

  componentDidMount() {
    if (this.props.changeValueInMount) {
      if (
        !_.isUndefined(this.state.default_value) &&
        !_.isNull(this.state.default_value) &&
        _.isNull(this.state.form_values)
      ) {
        this.props.EventMg.trigger('input_change_value', {
          id: this.props.id,
          value: this.state.default_value,
        });

        this.setState({
          form_values: this.state.default_value,
        });
      }
    }
  }

  componentDidUpdate(prevProps) {
    // 現場住所の内容を転記する機能がthis.is_enterに影響されないための対策
    if (
      COPY_FIELD_ADDRESS_TARGET.includes(this.props.id) &&
      prevProps.defaultValue !== this.props.defaultValue
    ) {
      this.setState({
        default_value: this.props.defaultValue,
        form_values: this.props.defaultValue,
      });
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    //defaultValueを変更した場合
    if (
      JSON.stringify(nextProps.defaultValue) !==
      JSON.stringify(this.state.default_value)
    ) {
      if (this.is_enter) {
        return;
      }

      if (!this.state.form_values) {
        // デフォルト値が変更されたとき
        this.props.EventMg.trigger('input_change_value', {
          id: this.props.id,
          value: nextProps.defaultValue,
        });
      }

      this.setState({
        default_value: nextProps.defaultValue,
        form_values: nextProps.defaultValue,
      });
    }

    //valueを変更した場合
    if (JSON.stringify(nextProps.value) !== JSON.stringify(this.state.value)) {
      if (this.is_enter) {
        return;
      }

      if (!this.state.form_values) {
        // デフォルト値が変更されたとき
        this.props.EventMg.trigger('input_change_value', {
          id: this.props.id,
          value: nextProps.value,
        });
      }

      this.setState({
        value: nextProps.value,
        default_value: nextProps.value,
        form_values: nextProps.value,
      });
    }
  }

  /**
   * @description アンマウントされるとき From Component に伝える
   */
  componentWillUnmount() {
    this.props.EventMg.trigger('delete_form_item', this.props.id);
  }

  /**
   * @description フォームの値をUpdateする関数
   * @param {Any} value フォームの値
   * @param {Any} params 任意のフォームの値
   */
  onUpdate(value, params) {
    value = deleteControlCode(value);
    let form_values = _.cloneDeep(this.state.form_values);
    if (!_.isUndefined(params)) {
      // 関数なら実行して結果を受け取る
      if (_.isFunction(params)) {
        form_values = params(value);
      } else {
        form_values = params;
      }
    } else if (!_.isUndefined(value)) {
      form_values = value;
    }

    if (
      this.props.fieldCompanyBranch === true &&
      this.state.form_values === form_values &&
      !_.isNull(form_values)
    ) {
      // 現場系画面_支店コンポーネント
      // 支店を選択している状態でコンポーネントを開き、何も変更をせずに閉じた場合、
      // 処理を中断
      return;
    }

    if (this.props.id === 'buildee_user_id' && _.isUndefined(value)) {
      // 現場系画面_Buildee担当者コンポーネント
      // 何も選択せずに閉じた場合、nullを代入
      form_values = null;
    }
    this.is_enter = true;
    this.setState({ form_values });
    if (_.some(this.noInputForm, id => id === this.props.id)) {
      // 入力フォーム以外から入力された場合、バリデーションチェック実行
      this.onValidationCheck(form_values);
    }
  }

  /**
   * @description バリデーションチェック実行
   * @param {Any} value null: 入力フォーム, null以外: 選択値
   */
  onValidationCheck(value = null) {
    this.props.EventMg.trigger('input_change_value', {
      id: this.props.id,
      value: _.isNull(value) ? this.state.form_values : value,
    });
  }

  render() {
    const value = this.is_enter
      ? _.clone(this.state.form_values)
      : _.clone(this.state.default_value);

    // 新しい Props を作成して children を描画
    return this.props.children({
      value,
      id: this.props.id,
      name: this.props.name,
      EventMg: this.props.EventMg,
      validate: this.props.validate,
      disabled: this.props.disabled,
      onUpdate: this.onUpdate.bind(this),
      onValidationCheck: this.onValidationCheck.bind(this),
      isRegister: this.props.isRegister,
    });
  }
}

/**
 * @description Form用の EventManager を作成
 */
export function createFormEventManager() {
  const FormEg = createLocalEventManager({
    SUBMIT: 'submit',
    CHANGE_VALUE: 'change_value',
    INPUT_CHANGE_VALUE: 'input_change_value',
    DELETE_FORM_ITEM: 'delete_form_item',
    REQUIRE_CHANGE_VALUE: 'require_change_value',
    UPDATE_VALIDATE: 'update_validate',
    UPDATE_CCUS_VALUE: 'update_ccus_value',
  });

  FormEg.isForm = true;

  return FormEg;
}

/**
 * @description 表示・非表示を切り替える。
 */
export const SwitchForm = ({ show, children, EventMg }) => {
  if (show) {
    if (!EventMg) {
      return children;
    }

    if (_.isArray(children)) {
      return React.Children.map(children, child => {
        return React.cloneElement(child, { EventMg });
      });
    } else {
      //react elementだけを返す
      if (children && children.$$typeof == Symbol.for('react.element')) {
        return React.cloneElement(children, { EventMg });
      }
      return null;
    }
  } else {
    return null;
  }
};



// WEBPACK FOOTER //
// ./src/components/FormBase.jsx